import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock, StyledSlider} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useInlineSizeSelectionQuickViewAB} from '../AddToBasketQuickView/hooks/useInlineSizeSelectionQuickViewAB';
import {SlideContainer} from '../ProductSlider/SliderContent';
import {useImagesSection} from '../useGetProductBulkSection';
import {
  ProductSliderQuickViewView,
  ProductSliderQuickViewViewProps,
} from './ProductSliderQuickViewView';

export const ProductSliderQuickView: React.FC<
  ProductSliderQuickViewViewProps
> = props => {
  return (
    <DataFetcher
      request={useImagesSection()}
      Error={null}
      Loading={Loading}
      View={ProductSliderQuickViewView}
      viewProps={props}
    />
  );
};

const Loading: React.FC = () => {
  const isInlineSizeSelectionQuickViewAB = useInlineSizeSelectionQuickViewAB();

  return (
    <StyledSkeletonBlock
      disableSpaceBelow
      disableRoundedCorners
      $largerGallery={isInlineSizeSelectionQuickViewAB}
    />
  );
};

const StyledSkeletonBlock = styled(SkeletonBlock)<{
  $largerGallery?: boolean;
}>`
  --height-calculation-unit: 100svh;
  @supports not (height: 100svh) {
    // iOS < 15.4. does not support sv-units
    --height-calculation-unit: 100vh;
    // This is an approximate value of the address- and navigation bar height on iOS < 15.4. since svh is not working there and vh does not take these bars into account
    --additional-height-reduction: 80px;
  }

  --image-gallery-height: clamp(
    330px,
    ${props => (props.$largerGallery ? '40svh' : '31svh')},
    400px
  );
  @supports not (height: 100svh) {
    --image-gallery-height: clamp(
      330px,
      ${props => (props.$largerGallery ? '40vh' : '31vh')},
      400px
    );
  }

  height: var(--image-gallery-height);
  width: 100%;
  padding: 0;

  ${SlideContainer} {
    height: var(--image-gallery-height);
    min-width: calc(var(--image-gallery-height) * (3 / 4));
    scroll-snap-align: start;

    margin-inline: 0;
  }

  ${StyledSlider} {
    gap: 2px;
    background-color: none;
  }
`;
